export const formatMX = (n: number) =>
  new Intl.NumberFormat("es-MX", {
    //style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
  
// export const formatMX = (n: number) =>
//   new Intl.NumberFormat("es-MX").format(verificarDerecha(n)) +
//   verificarIzquierda(n);

  const verificarIzquierda = (numero: number): string => {
  let numStr = numero.toString();
  if (numStr.includes(".")) {
    if (/^\d+\.\d$/.test(numStr)) {
      //quitamos los numero hacia la izquierda.
      const newNumer = numStr.split(".")[1];
      // Agregar un cero al final si cumple con el formato
      return "." + newNumer + "0";
    }
  }
  return ".00";
};

const verificarDerecha = (numero: number): number => {
  let numStr = numero.toString();
  if (numStr.includes(".")) {
    if (/^\d+\.\d$/.test(numStr)) {
      //quitamos los numero hacia la izquierda.
      const newNumer = numStr.split(".")[0];
      // Agregar un cero al final si cumple con el formato
      return Number(newNumer);
    }
  }
  return Number(numStr);
};
